import React from 'react'
import Centered from 'shared/ui/Centered'
import { Hero } from '../ui/Hero'
import Heading from 'shared/ui/Heading'
import AllBrands from '../ui/brands/AllBrands'
import Tiles from 'shared/ui/Tiles'
import TweetEmbed from 'shared/ui/TweetEmbed'
import tweetIds from '../data/tweetIds'

export default function Brands() {
  return (
    <div className="brands-page">
      <Hero>
        <div className="align-center">
          <Heading>Brands</Heading>
          <p>Trusted by the worlds top brands</p>
          <hr />
        </div>
      </Hero>

      <Centered>
        <div className="spacing-giant">
          <AllBrands />
          <section>
            <Heading className="align-center">And with wonderful reviews</Heading>
            <hr />
            <Tiles gutter={1.5} minSize={14}>
              {tweetIds.map(id => (
                <TweetEmbed
                  options={{
                    dnt: true,
                    cards: 'hidden',
                    conversation: 'none',
                  }}
                  id={id}
                  key={id}
                />
              ))}
            </Tiles>
          </section>
        </div>
      </Centered>
    </div>
  )
}
